import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState } from './types'
import * as actions from './actions'
import { Link } from 'react-router-dom'
import moment from 'moment'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'

export default () => {
  const [mounted, setMounted] = useState<boolean>(false)
  const { achievements, isProcessFetching } = useSelector(
    (state: { adminAchievements: InitialState }) => state.adminAchievements
  )

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchAchievements())
    setMounted(true)
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  return (
    <>
      <Header />
      <div className={'container'}>
        {!mounted || isProcessFetching ? (
          <LoadingPage />
        ) : (
          <>
            <h2>Панель администрирования - Достижения</h2>
            <table style={{ width: '100%', marginBottom: 40, marginTop: 10 }}>
              <thead>
                <tr>
                  <td>Название</td>
                  <td>Изображение</td>
                  <td>Дата создания</td>
                  <td>Вручений</td>
                  <td>Статус</td>
                </tr>
              </thead>
              <tbody>
                {achievements
                  ? achievements.map(achieve => (
                      <tr key={achieve.achievement_id}>
                        <td>
                          <Link
                            to={`/admin/achievements/${achieve.achievement_id}`}
                            style={{ marginLeft: 10 }}
                          >
                            {achieve.caption}
                          </Link>
                        </td>
                        <td
                          style={
                            achieve.image_media
                              ? {
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignContent: 'center',
                                }
                              : {}
                          }
                        >
                          {achieve.image_media ? (
                            <img
                              style={{ width: 100, height: 100 }}
                              src={achieve.image_media?.url}
                            />
                          ) : null}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {moment(achieve.created_at).format('LLLL')}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {achieve.user_achievements_count || 0}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {achieve.status === 'active' ? (
                            <p style={{ color: 'green' }}>Активный</p>
                          ) : (
                            <p style={{ color: 'red' }}>Не активный</p>
                          )}
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </table>
          </>
        )}
      </div>
      <Footer />
    </>
  )
}
